export const ROUTES = {
  HOME: `/`,
  WELCOME: "/welcome",
  PRINTER_SETTING: "/printer-setting",
  RECEPTION: "/reception",
  LOGIN: "/login",
  ADMIN_LOGIN: "/admin/:funeralId/login",
  ADMIN_ATTENDEE: "/admin/:funeralId/attendees",
  ADMIN_ATTENDEE_CREATE: "/admin/:funeralId/attendees/create",
  ADMIN_ATTENDEE_EDIT: "/admin/:funeralId/attendees/:receptionId/edit",
  ADMIN_ITEM_RECORD_BOOK: "/admin/:funeralId/item-record-book",
  ADMIN_TSUITOCHO: "/admin/:funeralId/tsuitocho",
  ADMIN_CONDOLENCE_GIFT_SYMBOL_SETTING: "/admin/:funeralId/condolence-gift-symbol-setting",
  ADMIN_CREATE_ITEM: "/admin/:funeralId/item/create",
  ADMIN_EDIT_ITEM: "/admin/:funeralId/item/:orderId/edit",
  ADMIN_PRINT_RECEIPT: "/admin/:funeralId/print-receipt",
  PHONE: `/phone`,
  ATTENDEE_INFO: `/attendee-info`,
  ATTENDEE_CONFIRM: "/attendee-info/confirm",
  NEW_ATTENDEE_INFO: `/new-attendee-info`,
  NEW_ATTENDEE_CONFIRM: "/new-attendee-info/confirm",
  NEW_ATTENDEE_REUSE: "/new-attendee-info/reuse",
  COMPLETE: "/complete",
  EDIT_OTHER_INFO: "/new-attendee-info/confirm/info",
  EDIT_GIFT_MONEY: "/new-attendee-info/confirm/money",
  PRIVACY_POLICY: "/privacy-policy",
  NEW_ATTENDEE_EDIT: "/new-attendee-info/edit",
  ATTENDEE_EDIT: "/attendee-info/edit",
};
